export class FileCategory {
  static readonly DeliveryOrder = new FileCategory('1', '出貨單', 'DeliveryOrder', null, 'DeliveryOrderDoc', false);
  static readonly Advising = new FileCategory('2', '進貨單', 'Advising', null, 'AdvisingDoc', false);
  static readonly FrontLine = new FileCategory('6', '助理附件', 'DeliveryOrder', 'FrontLineDoc', 'FrontLineDoc', true);
  static readonly CustomerLabel = new FileCategory('7', '標籤需求', 'DeliveryOrder', 'CustomerLabel', 'CustomerLabelDoc', false);
  static readonly HawbNo = new FileCategory('8', '提貨單', 'HawbNo', null, 'AdvisingDoc', false);

  private constructor(
    public readonly docCategory: string, //Logistics.Document.DocCategory (文件類型)
    public readonly taskClassName : string, //Logistics.Task.TaskClassName
    public readonly docReference : string, //Logistics.ShippingDocument.DocReference (存取文件使用)
    public readonly doLockHeader : string | null, //Logistics.DeliveryOrderLockHeader.LockHeaderType
    public readonly codeConverterType : string, //Common.CodeConverter.SubCategory (下拉選單用)
    public readonly canDeleteSystemFile: boolean  //Logistics.ShippingDocument.UpdateUser（刪除系統上傳的檔案）
  ){}
}
